module.exports = __webpack_public_path__ + "static/media/facebook.ef0413cc.svg";